module.exports = __webpack_public_path__ + "a37b0c01c0baf1888ca812cc0508f6e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.ttf
// module id = 254
// module chunks = 0 2